// KP-4621: catalog answers "Collection not found" (404) both for an unknown collection id
// and for a collection the retailer's segmentation hides completely. An empty page or
// filter result is a different 404 ("Product not found") and must keep the empty state.
export const COLLECTION_NOT_FOUND_MESSAGE = 'Collection not found'

export const isCollectionNotFoundError = err => err?.response?.status === 404
  && err?.response?.data?.message === COLLECTION_NOT_FOUND_MESSAGE
